import { useState, useEffect } from 'react';

export default function TestimonialSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote: "Talynt AI transformed our lead generation process. We're now booking 3x more qualified appointments with zero additional staff.",
      author: "Sarah Chen",
      title: "CEO, WellnessPro",
      industry: "Health & Wellness",
      result: "300% increase in qualified leads",
      image: "https://public.readdy.ai/ai/img_res/7b5a0e1ef7871274849ad79c306670ae.jpg"
    },
    {
      quote: "The A.I. staffing automation saved us 25 hours per week on candidate screening and placement. Our recruiters can now focus on building relationships.",
      author: "Michael Rodriguez",
      title: "Director, MedStaff Solutions",
      industry: "Healthcare Staffing",
      result: "25 hours saved weekly",
      image: "https://readdy.ai/api/search-image?query=Professional%20businessman%20director%20in%20healthcare%20staffing%20office%2C%20confident%20medical%20recruitment%20executive%2C%20clean%20corporate%20headshot%2C%20healthcare%20staffing%20leader%2C%20sophisticated%20business%20portrait%2C%20professional%20lighting&width=100&height=100&seq=michael&orientation=squarish"
    },
    {
      quote: "Our client onboarding improved by 60% after implementing their A.I. automation system. The compliance documentation is now seamless.",
      author: "Jennifer Park",
      title: "Managing Partner, TechServe MSP",
      industry: "Managed Service Providers",
      result: "60% faster onboarding",
      image: "https://readdy.ai/api/search-image?query=Professional%20businesswoman%20managing%20partner%20in%20technology%20office%2C%20confident%20MSP%20executive%2C%20clean%20corporate%20headshot%2C%20managed%20services%20leader%2C%20sophisticated%20business%20portrait%2C%20professional%20lighting&width=100&height=100&seq=jennifer&orientation=squarish"
    },
    {
      quote: "The A.I. client communication system increased our retention by 45% while reducing administrative overhead. ROI was immediate.",
      author: "David Thompson",
      title: "Senior Partner, LegalEase",
      industry: "Professional Services",
      result: "45% retention increase",
      image: "https://readdy.ai/api/search-image?query=Professional%20businessman%20senior%20partner%20in%20law%20office%2C%20confident%20legal%20services%20executive%2C%20clean%20corporate%20headshot%2C%20professional%20services%20leader%2C%20sophisticated%20business%20portrait%2C%20professional%20lighting&width=100&height=100&seq=david&orientation=squarish"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how businesses like yours are achieving remarkable results with our A.I. solutions.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-8">
              <div className="text-4xl text-blue-600 mb-6">
                <i className="ri-double-quotes-l"></i>
              </div>
              
              <blockquote className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8">
                "{testimonials[currentSlide].quote}"
              </blockquote>
              
              <div className="flex items-center justify-center space-x-4">
                <img 
                  src={testimonials[currentSlide].image}
                  alt={testimonials[currentSlide].author}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className="text-left">
                  <div className="font-semibold text-gray-900">
                    {testimonials[currentSlide].author}
                  </div>
                  <div className="text-gray-600">
                    {testimonials[currentSlide].title}
                  </div>
                  <div className="text-sm text-blue-600">
                    {testimonials[currentSlide].industry}
                  </div>
                </div>
              </div>
              
              <div className="mt-6 inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                {testimonials[currentSlide].result}
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  currentSlide === index 
                    ? 'bg-blue-600 w-8' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
